import type { BrowserInfo } from "@Common/types/bo/analytics_public/analytics_public";

export function collectBrowserInfo(): BrowserInfo {
	const userAgent =
		typeof navigator !== "undefined" && typeof navigator.userAgent === "string"
			? navigator.userAgent
			: null;

	const screenWidth =
		typeof screen !== "undefined" && typeof screen.width === "number"
			? screen.width
			: null;

	const screenHeight =
		typeof screen !== "undefined" && typeof screen.height === "number"
			? screen.height
			: null;

	const screenColorDepth =
		typeof screen !== "undefined" && typeof screen.colorDepth === "number"
			? screen.colorDepth
			: null;

	const devicePixelRatio =
		typeof window !== "undefined" && typeof window.devicePixelRatio === "number"
			? window.devicePixelRatio
			: null;

	const hardwareConcurrency =
		typeof navigator !== "undefined" &&
		typeof navigator.hardwareConcurrency === "number"
			? navigator.hardwareConcurrency
			: null;

	// navigator.deviceMemory is not available in all browsers (e.g. Firefox, Safari)
	const deviceMemory =
		typeof navigator !== "undefined" &&
		"deviceMemory" in navigator &&
		typeof (navigator as { deviceMemory?: number }).deviceMemory === "number"
			? (navigator as { deviceMemory: number }).deviceMemory
			: null;

	// navigator.languages is an array; we store as comma-separated string
	const languages =
		typeof navigator !== "undefined" &&
		Array.isArray(navigator.languages) &&
		navigator.languages.length > 0
			? navigator.languages.join(",")
			: null;

	const platform =
		typeof navigator !== "undefined" && typeof navigator.platform === "string"
			? navigator.platform
			: null;

	const cookieEnabled =
		typeof navigator !== "undefined" &&
		typeof navigator.cookieEnabled === "boolean"
			? navigator.cookieEnabled
			: null;

	// doNotTrack can be "1", "0", or null; store as TEXT to preserve original value
	const doNotTrack =
		typeof navigator !== "undefined" && navigator.doNotTrack !== undefined
			? navigator.doNotTrack
			: null;

	const timezone = (() => {
		try {
			return Intl.DateTimeFormat().resolvedOptions().timeZone ?? null;
		} catch {
			return null;
		}
	})();

	const screenOrientation =
		typeof screen !== "undefined" &&
		screen.orientation !== undefined &&
		typeof screen.orientation.type === "string"
			? screen.orientation.type
			: null;

	return {
		browser_user_agent: userAgent,
		browser_screen_width: screenWidth,
		browser_screen_height: screenHeight,
		browser_screen_color_depth: screenColorDepth,
		browser_device_pixel_ratio: devicePixelRatio,
		browser_hardware_concurrency: hardwareConcurrency,
		browser_device_memory: deviceMemory,
		browser_navigator_languages: languages,
		browser_navigator_platform: platform,
		browser_cookie_enabled: cookieEnabled,
		browser_do_not_track: doNotTrack,
		browser_timezone: timezone,
		browser_screen_orientation: screenOrientation,
	};
}
